import { FileDto } from './file';
import { AccountDto } from './account';
import { HashTagDto } from './hashtag';
import { PlaceDto } from './place';
import { ky } from './ky';
import { GeoLocation, ListResponse } from './common';
import TermsAgreementList from '@/components/complex/terms-agreement-list';
import { MeResponse } from './auth';

export interface TermsAgreementDto {
  id?: number;
  member?: MeResponse;
  content?: TermsContentDto;
  createdAt?: number;
  deletedAt?: number;
}

export interface TermsContentDto {
  id: number;
  termsId: number;
  version: string;
  content: string;
  startAt?: string;
  endAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface TermsDto {
  id: number;
  code?: string;
  title?: string;
  agreementRequired?: boolean;
  currentContent?: TermsContentDto;
  createdAt?: string;
  updatedAt?: string;
}


export interface TermsGroupDto {
  id: number;
  code: string;
  name: string;
  description: string;
  terms?: TermsDto[],
  createdAt?: string;
  updatedAt?: string;
}

export default class TermsService {

  /**
   * 약관 그룹 가져오기
   *
   * @param code 그룹 코드
   */
  async getGroup(code: string) {
    const response = await ky.get(`v1/terms/groups/${code}`)
    return await response.json() as TermsGroupDto;
  }

  /**
   * 약관 그룹 가져오기
   *
   * @param termsCode 약관 코드
   * @param contentId 약관 내용 ID
   */
  async getContent(termsCode: string) {
    const response = await ky.get(`v1/terms/${termsCode}`)
    return await response.json() as TermsDto;
  }

  /**
   * 약관 동의
   * @param terms 동의할 약관 리스트
   */
  async agree(terms: TermsAgreementDto[]) {
    await ky.post('v1/terms/agreements/bulk', {
      json: { list: terms }
    })
  }

}
